import { BaseApi } from "@newview/infrastructure";
export abstract class CompletionSystemBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'CompletionSystemApi';
    }
  
}